module.exports = __webpack_public_path__ + "static/media/Path 7.8ec2943b.svg";